<template>
  <div class="menucontrol-scroll fixed-top">
    <Banner />
    <SeoTable />
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
import SeoTable from "./components/SeoTable.vue";
export default {
  components: {
    Banner,
    SeoTable,
  },
};
</script>
